var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFullImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFullImage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open-image1",
    transform: "translate(-324.000000, -30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(9.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFullImage",
    transform: "translate(315.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    fill: "#FFFFFF",
    opacity: 0.2,
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Full-screen-white",
    transform: "translate(10.000000, 10.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.1742629 L0,17.3730134 L4.4408921e-16,17.3730134 C5.7935996e-16,18.4775829 0.8954305,19.3730134 2,19.3730134 L7.61904762,19.3730134",
    id: "Path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.745691459 L0,5.94444197 L4.4408921e-16,5.94444197 C5.7935996e-16,7.04901147 0.8954305,7.94444197 2,7.94444197 L7.61904762,7.94444197",
    id: "Path-17",
    transform: "translate(3.809524, 4.345067) scale(1, -1) translate(-3.809524, -4.345067) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 10.000000) scale(-1, 1) translate(-16.000000, -10.000000) translate(12.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11 L0,16 L4.4408921e-16,16 C8.88325637e-17,17.1045695 0.8954305,18 2,18 L8,18",
    id: "Path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,5 L4.4408921e-16,5 C8.88325637e-17,6.1045695 0.8954305,7 2,7 L8,7",
    id: "Path-17",
    transform: "translate(4.000000, 3.500000) scale(1, -1) translate(-4.000000, -3.500000) "
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFullImage);
export default __webpack_public_path__ + "static/media/icFullImage.195a9d4547cb779db6256d937a164631.svg";
export { ForwardRef as ReactComponent };